import {Model} from '@/models/Model'

export class Link {

  first: string
  last: string
  next: string
  prev: string

}

export class Meta {

  current_page: number
  from: number
  path: string
  per_page: number
  to: number
}

export class DataResource {
  constructor(response: any = []) {
    this.data = response.data
  }

  data: Model
}

export class DataArray {
  constructor(response: any = []) {
    this.data = response.data
  }

  data: any
  links: Link
  meta: Meta
  filter: any
  summary: any
}

export class FilterSet {
  constructor(current: FilterOption[] = []) {
    this.current = current
  }

  label: string = ''
  current: FilterOption[] = []
  options: FilterOption[] = []
}

export class FilterOption {
  text: string
  key: string
  count: number
}